const general = {
  EN: {
    all: 'All',
    noData: 'No data found',
    button: {
      addNew: 'Add new',
      clear: 'Clear',
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      deleteAccount: 'I understand the consequences, delete this account',
      confirm: 'Confirm',
      browsefile: 'Browse File',
      search: 'Search',
      complete: 'Complete',
      waiting: 'Waiting',
      submit: 'Submit',
      assign: 'Assign',
      sync: 'Sync',
      invite: 'Invite',
      clearFilters: 'Clear all filters',
    },
    select: {
      datetime: 'Select Datetime',
    },
    notification: {
      alert: 'Alert',
      createSuccess: 'Creation Successful!',
      updateSuccess: 'Updated Successful!',
      cannotDelete: "Can't delete data ID: ",
    },
    errors: {
      noDescription: 'An error occurred',
      noRoom: 'Please select a room before booking!',
      noSize: 'This file exceeds the maximum size of 1 MB.',
      timePassed: 'The selected period has already passed',
      timeConfig: 'The selected time slot must be booked in advance.',
      timeConfigMin: 'minute',
      almostMidnight:
        'There are no time slots available for today, please reserve the following day.',
      cannotReserve: 'Reservation Unavailable',
      noOfBookRoomSameTime: 'Unable to reserve for multiple days at once',
      noRoomsAvailable: 'Conflicts with existing meetings in selected rooms',
    },
    schema: {
      date: {
        format: {
          main: 'Invalid date format',
        },
        startDate: {
          required: 'Start date is required',
        },
        endDate: {
          min: 'End date cannot be earlier than start date',
          required: 'End date is required',
        },
      },
    },
    comingSoon: 'Coming soon . . .',
    edit: 'Edit',
    none: 'None',
  },
  TH: {
    all: 'ทั้งหมด',
    noData: 'ไม่พบข้อมูล',
    button: {
      addNew: 'เพิ่มใหม่',
      clear: 'ล้าง',
      save: 'บันทึก',
      cancel: 'ยกเลิก',
      deleteAccount: 'ฉันเข้าใจผลที่จะตามมา, ลบบัญชีนี้',
      delete: 'ลบ',
      confirm: 'ยืนยัน',
      browsefile: 'เลือกไฟล์',
      search: 'ค้นหา',
      complete: 'สำเร็จ',
      waiting: 'รอสักครู่',
      submit: 'ส่ง',
      assign: 'กำหนด',
      sync: 'ซิงค์',
      invite: 'เชิญชวน',
      clearFilters: 'ล้างการค้นหา',
    },
    errors: {
      noDescription: 'เกิดข้อผิดพลาด',
      noRoom: 'กรุณาเลือกห้องก่อนจอง!',
      noSize: 'ไฟล์มีขนาดเกิน 1 MB',
      timePassed: 'ช่วงเวลาที่เลือกผ่านไปแล้ว',
      timeConfig: 'ช่วงเวลาที่เลือกต้องจองล่วงหน้า',
      timeConfigMin: 'นาที',
      almostMidnight: 'ไม่มีช่วงเวลาที่ว่างสำหรับวันนี้ กรุณาจองวันถัดไป',
      cannotReserve: 'ไม่สามารถจองได้',
      noOfBookRoomSameTime: 'ไม่สามารถจองห้องสำหรับหลายวันพร้อมกันได้',
      noRoomsAvailable: 'ไม่สามารถจองได้ เนื่องจากช่วงเวลาดังกล่าวมีผู้อื่นจองแล้ว',
    },
    comingSoon: 'เร็ว ๆ นี้ . . .',
    edit: 'แก้ไข',
    none: 'ไม่มีข้อมูล',
  },
};

export default general;
